/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Scheduled_Sync_HintInputs */



/**
* | output |
* | --- |
* | "Syncs the whole space again on this schedule. Changes made in between show up after the next sync." |
*
* @param {Spaces_Scheduled_Sync_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_scheduled_sync_hint = /** @type {((inputs?: Spaces_Scheduled_Sync_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Scheduled_Sync_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisiert den gesamten Space nach diesem Zeitplan erneut. Zwischenzeitliche Änderungen erscheinen nach der nächsten Synchronisierung.")
	return /** @type {LocalizedString} */ ("Syncs the whole space again on this schedule. Changes made in between show up after the next sync.")
});